import { date } from '@/schemas/API/common/atomic/date';
import { sex } from '@/schemas/API/common/atomic/sex';
import { time } from '@/schemas/API/common/atomic/time';
import dayjs from 'dayjs';
import { z } from 'zod';

// for task and taskgroup
const taskRequestSchema = z.object({
  date,
  boundStartTime: time,
  boundEndTime: time,
  startTime: time,
  byMonthDay: z.array(z.number()),
  duration: z.number(),
  name: z.string(),
  note: z.string().nullable(),
  inclTask: z.number().nullable(),
  prefSex: sex,
  tags: z.array(z.number()),
});

export const defaultTaskRequestSchema: TaskRequest = {
  date: dayjs().format('YYYY-MM-DD'),
  boundStartTime: '',
  boundEndTime: '',
  startTime: '',
  byMonthDay: [],
  duration: 0,
  name: '',
  note: null,
  inclTask: null,
  prefSex: 'O',
  tags: [],
};

export type TaskRequest = z.infer<typeof taskRequestSchema>;
